module.exports = __webpack_public_path__ + "media/images/icons/duration-clock-e85872a60732360fb5f0c06bcfb99138.svg";